var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UIButton", {
    attrs: {
      variant: _vm.variant,
      buttonText: "Invite to Interview",
      fullWidth: "",
      size: _vm.size,
      disabled: _vm.disabled,
    },
    on: { click: _vm.interviewApplicant },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }